import {FlagsProvider} from "@atlaskit/flag";
import type {ComponentProps} from "react";

export function AnankeFlagProvider(props: ComponentProps<typeof FlagsProvider>) {
    return <FlagsProvider {...props} />;
}
